export default function DeleteChatIcon({ color = "#555555" }) {
    return (
        <div style={{ textAlign: "center", height: '20px', width: '20px', alignContent: 'center', alignItems: 'center'}} >
            <svg
                width={18}
                height={18}
                viewBox="0 0 24 24"
                fill="none"
                aria-label="Delete chat"
                role="img"
            >
                <path
                    d="M3 6h18M8 6V4a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v2m3 0-1 14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2L4 6h16ZM10 11v6M14 11v6"
                    stroke={color}
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        </div>
    );
}